import { setStorage, getStorage, getTempInfo, mergeObjectEasy, syncAddUserInfo } from '../common.js';
import Util from "../util.js";
import { syncAccountMobileNo, syncAccountRequestId } from "./investmentAction.js";
import { Toast } from 'antd-mobile/lib';

//是否有登录记录
export const isLogin = (text) => {return {type: 'IS_LOGIN', text}; };

export const userId = (text) => {
    return {
        type: 'TEMP_INFO_USER_ID',
        text
    };
}

export const trueName = (text) => {
    return {
        type: 'TEMP_INFO_TRUE_NAME',
        text
    };
}

export const tradeAccountNo = (text) => {
    return {
        type: 'TEMP_INFO_TRADE_ACCOUNT_NO',
        text
    };
}

export const userName = (text) => {
    return {
        type: 'TEMP_INFO_USER_NAME',
        text
    };
}

export const nickName = (text) => {
    return {
        type: 'TEMP_INFO_NICK_NAME',
        text
    };
}

export const userMobileNo = (text) => {
    return {
        type: 'TEMP_INFO_USER_MOBILE_NO',
        text
    };
}

export const isPrivate = (text) => {
    return {
        type: 'TEMP_INFO_IS_PRIVATE',
        text
    };
}

export const shortToken = (text)=>{
    return {
        type: 'TEMP_INFO_SHORT_TOKEN',
        text
    };
}

export const longToken = (text) => {
    return {
        type: 'TEMP_INFO_LONG_TOKEN',
        text
    };
}

export const verifiedUserInfo = (text) => {
    return {
        type: 'VERIFIEDUSERINFO',
        text
    };
}


/*当用户退出或更换用户时清楚数据*/
export const cleanCache = (dispatch)=>{
  window.localStorage.removeItem('currentUserInfo');
  window.localStorage.removeItem('loginInfo-longToken');
  window.localStorage.removeItem('loginInfo-shortToken');
  window.localStorage.removeItem('loginState')
  dispatch(isLogin(false));
  dispatch(userMobileNo(""));
  // dispatch(myInvestmentList({code:'',message:'',content:{records:[]}}));
  // dispatch(payInfo({code:'',message:'',content:{shareList:[],currentAccountList:[],currentNav:'',currentNavDate:'',fundCode:'',fundName:'',minAmount:''}}))
  // dispatch(myInvestListGm([]));
  // dispatch(myInvestListJhlc([]));
  // dispatch(myInvestListZh([]))
  // dispatch(myInvestListSm([]));
  // dispatch(myInvestListSuperFund([]));
  // dispatch(myInvestList([]));
  dispatch(verifiedUserInfo(null));
  // dispatch(unVerifiedUserInfo(null));
  // dispatch(isLogin(false));
  // dispatch(isRealName(false));
  // dispatch(SupperFundHome(null));
  // dispatch(QueryTransitRecords(null));
  // dispatch(assetInTransitList([]));
  // dispatch(bankCardNum('--'));
  // dispatch(bankCardList([]));
  // dispatch(HQTCardList([]));
  // dispatch(myInvestAccount('--'));
  // dispatch(myTrustChannelShare({fundInfo:{},trustChannelShareResponse:[],isOpenBuy:true,fundIncome:[{allIncome:0,dayIncome:'',deadLine:null}]}))
  // dispatch(tempInfo['userInfo']['mobileNo'](''));
  // dispatch(incomeDigital({customerTotalValue: '--', dayIncome: '--', allIncome: '--', endDate: '- -', transitTotalValue: '--'}));
}

//华夏财富手机号登录
export const loginHXFortuneByMobile = (loginParam, succallback, errcallback)=>{
    return (dispatch, getState)=>{
        const successCallback = async (succ)=>{
            console.log(succ);
            if(succ && succ.code === '0000'){
              cleanCache(dispatch);
              let TM=new Date()
              setStorage('tokenTimeLong',TM.getTime()+window.tokenTimeLong);
              setStorage('tokenTimeshort',TM.getTime()+window.tokenTimeshort);
              let userInfo = {
                userId: succ.content.userId,
                isRealName: succ.content.tradeAccountNo ? true : false
              }
              if(succ.content.name != undefined)
                userInfo = mergeObjectEasy(userInfo, {name: succ.content.name});
              if(succ.content.nickName != undefined)
                userInfo = mergeObjectEasy(userInfo, {nickName: succ.content.nickName});
              if(succ.content.tradeAccountNo != undefined)
                userInfo = mergeObjectEasy(userInfo, {tradeAccountNo: succ.content.tradeAccountNo});
              userInfo.mobileNo = loginParam.mobileNo;
              console.log('华夏财富手机号登录userInfo', userInfo);
              let user = await getTempInfo('userList-'+userInfo.userId);
              console.log('华夏财富手机号登录userInfo', user);
              if(user!=9999){
                userInfo = mergeObjectEasy(user, userInfo);
              }
              console.log('华夏财富手机号登录userInfo', userInfo);
              setStorage('currentUserInfo', userInfo);
              setStorage('userList-' + userInfo.userId, userInfo);
              setStorage('loginInfo-shortToken', succ.content.shortToken);
              setStorage('loginInfo-longToken', succ.content.longToken);
              dispatch(isLogin(true));
              dispatch(userMobileNo(loginParam.mobileNo));
              if(userInfo.isRealName) {
                setStorage("loginState", '2');
              }else {
                setStorage("loginState", '1');
              }
              dispatch(getUserInfoList());
                succallback(userInfo);
                console.log(succ);
            }else{
                console.log('后台返回数据有误!');
                errcallback(succ.message);
            }
        };
        const errorCallback = (err)=>{
            console.log(err);
            errcallback(Util.errorTxt);
        };
        Util.post(Util.url + '/api/account/mobileLogin', loginParam, successCallback, errorCallback);
    }
}

//华夏财富身份证登录
export const loginHXFortuneByIdentity = (loginParam, succallback, errcallback)=>{
    return (dispatch, getState)=>{
        const successCallback = async (succ)=>{
            console.log(succ);
            if(succ && succ.code === '0000'){
              cleanCache(dispatch);
              let TM=new Date()
              setStorage('tokenTimeLong',TM.getTime()+window.tokenTimeLong);
              setStorage('tokenTimeshort',TM.getTime()+window.tokenTimeshort);
              if(succ.content.userId){
                let userInfo = {
                  userId: succ.content.userId,
                  isRealName: succ.content.tradeAccountNo ? true : false
                }
                if(succ.content.name != undefined)
                  userInfo = mergeObjectEasy(userInfo, {name: succ.content.name});
                if(succ.content.nickName != undefined)
                  userInfo = mergeObjectEasy(userInfo, {nickName: succ.content.nickName});
                if(succ.content.tradeAccountNo != undefined)
                  userInfo = mergeObjectEasy(userInfo, {tradeAccountNo: succ.content.tradeAccountNo});
                console.log('华夏财富证件号登录userInfo', userInfo);
                let user = await getTempInfo('userList-'+userInfo.userId);
                if(user!=9999){
                  userInfo = mergeObjectEasy(user, userInfo);
                }
                setStorage('currentUserInfo', userInfo);
                setStorage('userList-' + userInfo.userId, userInfo);
                setStorage('loginInfo-shortToken', succ.content.shortToken);
                setStorage('loginInfo-longToken', succ.content.longToken);
                dispatch(isLogin(true));
                console.log('21212121212华夏财富证件号登录userInfo', userInfo);
                if(userInfo.isRealName) {
                  setStorage("loginState", '2');
                }else {
                  setStorage("loginState", '1');
                }
                dispatch(getUserInfoList());
              }
              let userInfoT = {
                  ...succ.content,
                  userId: succ.content.userId ? succ.content.userId : null,
                  isRealName: succ.content.tradeAccountNo ? true : false,
                  shortToken: succ.content.shortToken,
                  tradeAccountNo: succ.content.tradeAccountNo,

                }
                setStorage('loginInfo-shortToken', succ.content.shortToken);
                setStorage('loginInfo-longToken', succ.content.longToken);
                succallback(userInfoT);
                console.log(succ);
            }else{
                console.log('后台返回数据有误!');
                errcallback(succ.message);
            }
        };
        const errorCallback = (err)=>{
            console.log(err);
            errcallback(Util.errorTxt);
        };
        Util.post(Util.url + '/api/account/certLogin', loginParam, successCallback, errorCallback);
    }
}
//获取个人信息
export function getUserInfoList(callback) {
  return function(dispatch, getState) {
    const successCallback = async (data)=>{
      if(data.code == "0000") {
        let flagDigital= await getStorage('loginState');
        if(flagDigital!='1'){ 
          dispatch(verifiedUserInfo(data));
        }else {
          dispatch(verifiedUserInfo(null));
        }
        let currentUserInfo=await getStorage('currentUserInfo');
        console.log(currentUserInfo)
        currentUserInfo.mobileNo = data.content.mobileNo;
        currentUserInfo.userMsg=data.content;
        setStorage('currentUserInfo',currentUserInfo);
        if(callback) {
          callback(data);
        }
        console.log(currentUserInfo);
        console.log("个人信息");
        console.log(data)
        let addInfo = {};
        if(data.content.mobileNo){
          addInfo.mobileNo = data.content.mobileNo;
        }
        if(data.content.name){
          addInfo.name = data.content.name;
        }
        if(data.content.nickName){
          addInfo.nickName = data.content.nickName;
        }
        if(data.content.isPrivate){
          addInfo.isPrivate = data.content.isPrivate;
        }
        addInfo.userMsg = data.content;
        dispatch(nickName(data.content.nickName ? data.content.nickName: null));
        dispatch(trueName(data.content.name ? data.content.name : null));
        dispatch(userMobileNo(data.content.mobileNo ? data.content.mobileNo : null));
        dispatch(isPrivate(data.content.isPrivate ? data.content.isPrivate : null));
        syncAddUserInfo({addInfo: addInfo});
      }else {
        dispatch(verifiedUserInfo(null));
        let currentUserInfo=await getStorage('currentUserInfo');
        if(currentUserInfo && currentUserInfo.mobileNo)
          dispatch(userMobileNo(currentUserInfo.mobileNo));
        else
          dispatch(userMobileNo(null));
        if(currentUserInfo && currentUserInfo.nickName)
          dispatch(nickName(currentUserInfo.nickName));
        else
          dispatch(nickName(null));
        if(currentUserInfo && currentUserInfo.name)
          dispatch(trueName(currentUserInfo.name));
        else
          dispatch(trueName(null));
        if(currentUserInfo && currentUserInfo.isPrivate)
          dispatch(isPrivate(currentUserInfo.isPrivate));
        else
          dispatch(isPrivate(null));
          console.log(data.code);
        if(callback) {
          callback();
        }
      }
    };
    const errorCallback = async (err)=>{
      dispatch(verifiedUserInfo(null));
      let currentUserInfo=await getStorage('currentUserInfo');
      if(currentUserInfo && currentUserInfo.mobileNo)
        dispatch(userMobileNo(currentUserInfo.mobileNo));
      else
        dispatch(userMobileNo(null));
      if(currentUserInfo && currentUserInfo.nickName)
        dispatch(nickName(currentUserInfo.nickName));
      else
        dispatch(nickName(null));
      if(currentUserInfo && currentUserInfo.name)
        dispatch(trueName(currentUserInfo.name));
      else
        dispatch(trueName(null));
      if(currentUserInfo && currentUserInfo.isPrivate)
        dispatch(isPrivate(currentUserInfo.isPrivate));
      else
        dispatch(isPrivate(null));
      console.log(err);
      if(callback) {
        callback();
      }
    };
    getTempInfo("shortToken").then((token) => {
      if(token == null) {
        token = "";
      }
      Util.post(Util.url + "/api/account/getRealUserInfo" , {token:token}, successCallback, errorCallback);
      
    });
  }
}

export function getUserInfoListTemp(callback) {
  return function(dispatch, getState) {
    const successCallback = async (data)=>{
      if(data.code == "0000") {
        if(callback){
          console.log(data)
          callback(data.content)
        }
      }else {
        console.log(data.code);
      }
    };
    const errorCallback = async (err)=>{
      console.log(err);
    };
    getTempInfo("shortToken").then((token) => {
      if(token == null) {
        token = "";
      }
      Util.post(Util.url + "/api/account/getRealUserInfo" , {token:token}, successCallback, errorCallback);
      
    });
  }
}

//通过验证码验证手机号,并绑定手机号
export const userBindingMobile = (verifyParam, loginContent ,succallback, errcallback) => {
  return async (dispatch, getState)=>{
    // dispatch(pageFlag(true));
    const successCallback = async (succ)=>{
      // dispatch(pageFlag(false));
      console.log(succ);
      if(succ && succ.code === '0000'){
          cleanCache(dispatch);
          let TM=new Date()
          setStorage('tokenTimeLong',TM.getTime()+window.tokenTimeLong);
          setStorage('tokenTimeshort',TM.getTime()+window.tokenTimeshort);
          let userInfo = {
              userId: succ.content.userId,
              isRealName: loginContent.tradeAccountNo ? true : false
            }
            if(loginContent.name != undefined)
              userInfo = mergeObjectEasy(userInfo, {name: loginContent.name});
            if(loginContent.nickName != undefined)
              userInfo = mergeObjectEasy(userInfo, {nickName: loginContent.nickName});
            if(loginContent.tradeAccountNo != undefined)
              userInfo = mergeObjectEasy(userInfo, {tradeAccountNo: loginContent.tradeAccountNo});
            userInfo.mobileNo = verifyParam.mobileNo;
            console.log('绑定手机号后userInfo', userInfo);
            let user = await getTempInfo('userList-'+userInfo.userId);
            if(user){
              userInfo = mergeObjectEasy(user, userInfo);
            }
            setStorage('currentUserInfo', userInfo);
            setStorage('userList-' + userInfo.userId, userInfo);
            setStorage('loginInfo-shortToken', succ.content.shortToken);
            setStorage('loginInfo-longToken', succ.content.longToken);
            dispatch(isLogin(true));
            console.log(userInfo,loginContent,'qw2ewqdq')
            if(userInfo.isRealName) {
              setStorage("loginState", '2');
            }else {
              setStorage("loginState", '1');
            }
            dispatch(userMobileNo(verifyParam.mobileNo));
            dispatch(getUserInfoList());
          succallback();
      }else{
        console.log('后台返回数据有误！' + succ.message);
        errcallback(succ.message);
      }
    };
    const errorCallback = (err)=>{
      // dispatch(pageFlag(false));
      console.log(err);
      errcallback(Util.errorTxt);
    };
    Util.post(Util.url + '/api/account/bindingMobileNo', verifyParam, successCallback, errorCallback);
  }
}


//注册
export const registerAccount = (params, succallback, errcallback)=>{
  return (dispatch, getState)=>{
    params.clientType=Util.return_Clinet_Type();
      // dispatch(pageFlag(true));
    const successCallback = async (succ)=>{
        // dispatch(pageFlag(false));
      if(succ && succ.code === '0000'){
        cleanCache(dispatch);
        let TM=new Date()
        setStorage('tokenTimeLong',TM.getTime()+window.tokenTimeLong);
        setStorage('tokenTimeshort',TM.getTime()+window.tokenTimeshort);
        let userInfo = {
            userId: succ.content.userId,
            isRealName: succ.content.tradeAccountNo ? true : false
          }
          if(succ.content.name != undefined)
            userInfo = mergeObjectEasy(userInfo, {name: succ.content.name});
          if(succ.content.nickName != undefined)
            userInfo = mergeObjectEasy(userInfo, {nickName: succ.content.nickName});
          if(succ.content.tradeAccountNo != undefined)
            userInfo = mergeObjectEasy(userInfo, {tradeAccountNo: succ.content.tradeAccountNo});
          userInfo.mobileNo = params.mobileNo;
          console.log('注册userInfo', userInfo);
          let user = await getTempInfo('userList-'+userInfo.userId);
          if(user!=9999){
            userInfo = mergeObjectEasy(user, userInfo);
          }
          setStorage('currentUserInfo', userInfo);
          setStorage('userList-' + userInfo.userId, userInfo);
          setStorage('loginInfo-shortToken', succ.content.shortToken);
          setStorage('loginInfo-longToken', succ.content.longToken);
          dispatch(isLogin(true));
          if(userInfo.isRealName) {
            setStorage("loginState", '2');
          }else {
            setStorage("loginState", '1');
          }
          dispatch(userMobileNo(params.mobileNo));
        console.log(succ);
        //dispatch(getUserInfoList());
        succallback();
      }else{
        console.log(succ);
        console.log('后台返回数据有误');
        errcallback(succ.message);
      }
    };
    const errorCallback = (err)=>{
        // dispatch(pageFlag(false));

      console.log(err);
      errcallback(Util.errorTxt);
    };
    Util.post(Util.url + '/api/account/register', params, successCallback, errorCallback);
  }
}

//预约理财师
export const ReservationManager = (paramsInit,callback) =>{
  return (dispatch, getState)=>{
    paramsInit.clientType=Util.return_Clinet_Type();
    const successCallback = (succ)=>{
      if(succ && succ.code == '0000'){
        // Toast.info(succ.message, Util.ToastTime );
        callback(succ.content)
        console.log(succ);
      }else{
        console.log(succ);
        Toast.info(succ.message, Util.ToastTime );
        console.log('后台返回数据有误!');
      }
    };
    const errorCallback = (err)=>{
      Toast.info("预约失败", Util.ToastTime );
      console.log(err);
    };
    Util.get(Util.url + '/api/consultant/consultantSubmit', paramsInit, successCallback, errorCallback);
  }
}

//获取图片验证码
export const getCapchaCode = (params, succallback, errcallback) => {
  console.log('9999', params);
  return (dispatch, getState)=>{
    const successCallback = (succ)=>{
      if(succ && succ.code == '0000'){
        console.log(succ);
        succallback(succ.content.verifyCode, succ.content.base64Img);
      }else{
        console.log(succ);
        console.log('后台返回数据有误!');
        errcallback(succ.message);
      }
    };
    const errorCallback = (err)=>{
      console.log(err);
      errcallback(Util.errorTxt);
    };
    Util.post(Util.url + '/api/account/verifyCode', params ,successCallback, errorCallback);
  }
}

//查询是否签署同步协议
export function getTbuxy(params,callback){
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then((data) => {
      params.token=data
      console.log(params,data);
      Util.get(Util.url+"/aml/sign/isSyncAccount",params,function(res){
        console.log(res);
        if(res.code == "0000"){
          callback(res.content)
        }else{
          Toast.info(res.message,2)
        }
      },function(error){
        console.log(error)
      })
     })
  }
}

//同步协议签署
export function getTbuxyQis(params,callback){
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then((data) => {
      params.token=data
      console.log(params,data);
      Util.get(Util.url+"/aml/sign/syncAccountInformation",params,function(res){
        console.log(res);
        if(res.code == "0000"){
          callback(res.content)
        }else{
          Toast.info(res.message,2)
        }
      },function(error){
        console.log(error)
      })
     })
  }
}

//财富开户直销
export function getTbuxyKh(params,callback){
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then((data) => {
      let randomInt = Math.floor(1 + Math.random() * 10000);
      const successCallback = (succ)=>{
        if(succ && succ.code === '0000'){
          callback(succ.content);
        }else{
          Toast.info(succ.message,2)
        }
      };
      const errorCallback = (err)=>{
        Toast.info(Util.errorTxt)
      };
      params.token = data
      params.clientType = Util.return_Clinet_Type()
      params.clientDeviceNo = "hxcfH5"+randomInt,
      Util.postNew(Util.url + '/api/v1/account/syncOpenOtsAccount', params, successCallback, errorCallback);
     })
  }
}

//未登录-校验图形验证码后获取手机验证码
export const getMobileCaptcha = (params, succallback, errcallback,fun=null) => {
	return (dispatch, getState)=>{
		console.log(params)
		const successCallback = (succ)=>{
			if(succ && succ.code == '0000'){
				console.log(succ);
				succallback(succ.content);
			}else{
				console.log(succ);
				if(fun){
					errcallback(fun);
					return;
				}
				errcallback(succ);
			}
		};
		const errorCallback = (err)=>{
			// Toast.show(Util.errorTxt, getToastConfPoint());
			console.log(err);
			// callback('');
		};
		Util.post(Util.url + '/api/mobileCaptcha/getMobileCaptcha', params, successCallback, errorCallback);
	}
}
//新获取图片验证码 20/3/12
export const getCapcha = ( succallback, errcallback) => {
	return (dispatch, getState)=>{
		const successCallback = (succ)=>{
			if(succ && succ.code == '0000'){
				console.log(succ);
				succallback(succ.content.token, succ.content.base64);
			}else{
				console.log(succ);
				console.log('后台返回数据有误!');
				errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
			console.log(err);
			errcallback(Util.errorTxt);
		};
		Util.post(Util.url + '/api/captcha/getCaptcha',{},successCallback, errorCallback);
	}
}

//重置登录密码
export const resetPassword=(params, succallback, errcallback)=>{
  return (dispatch, getState)=>{
    const successCallback = (succ)=>{
      if(succ && succ.code === '0000'){
        console.log(succ);
        succallback(succ.message);
      }else{
        console.log(succ);
        console.log('后台返回数据有误');
        errcallback(succ.message);
      }
    };
    const errorCallback = (err)=>{
      console.log(err);
      errcallback(Util.errorTxt);
    };
    Util.post(Util.url + '/api/account/resetLoginPassword', params, successCallback, errorCallback);
  }
}

//2019.12.23 修改后的重置登陆密码接口
export const forgetPassword=(params, succallback, errcallback)=>{
  return (dispatch, getState)=>{
    const successCallback = (succ)=>{
      if(succ && succ.code === '0000'){
        console.log(succ);
        succallback(succ.message);
      }else{
        console.log(succ);
        console.log('后台返回数据有误');
        errcallback(succ.message);
      }
    };
    const errorCallback = (err)=>{
      console.log(err);
      errcallback(Util.errorTxt);
    };
    Util.post(Util.url + '/api/password/forgetPassword', params, successCallback, errorCallback);
  }
}

//修改登录密码
export const updateLoginPassword = (params, succallback, errcallback)=>{
  return (dispatch, getState)=>{
    const successCallback = (succ)=>{
      console.log(succ);
      if(succ && succ.code === '0000'){
        console.log('修改登录密码成功',succ);
        succallback();
      }else{
        console.log('修改登录密码失败，服务器返回错误');
        errcallback(succ.message);
      }
    };
    const errorCallback = (err)=>{
      console.log('修改登录密码请求失败！');
      errcallback(Util.errorTxt);
    };
    Util.post(Util.url + '/api/account/editLoginPassword', params, successCallback, errorCallback);
  }
}

//修改交易密码
export const updateTradePassword = (params, succallback, errcallback)=>{
  return (dispatch, getState)=>{
    const successCallback = (succ)=>{
      if(succ && succ.code === '0000'){
        console.log('修改交易密码成功',succ);
        succallback();
      }else{
        console.log('后台返回数据有误');
        errcallback(succ.message);        
      }
    };
    const errorCallback = (err)=>{
      console.log('修改交易密码请求失败！');
      errcallback(Util.errorTxt);
    };
    Util.post(Util.url + '/api/account/updateTradePassword', params, successCallback, errorCallback);
  }
}


// WEBPACK FOOTER //
// ./src/action/loginAction.js